// extracted by mini-css-extract-plugin
export default {"units-header":"style_units-header__GRf+T","unit":"style_unit__N3ZJM","avg-weight":"style_avg-weight__X6fXJ","row":"style_row__Uqn-j"};